import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { customerRoutes } from './routes/customer.routes';
import { errorRoutes } from './routes/error.routes';

export const appRoutes: Route[] = [
  {
    path: 'terms/:type',
    loadComponent: () => import('./pages/terms/terms.page'),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', loadComponent: () => import('./pages/home/home.page') },
      {
        path: 'about',
        loadComponent: () => import('./pages/about/about.page'),
      },
      {
        path: 'product',
        loadComponent: () => import('./pages/product/product.page'),
      },
      {
        path: 'product/:id',
        loadComponent: () =>
          import('./pages/product/product-detail/product-detail.page'),
      },
      ...customerRoutes,
      ...errorRoutes,
    ],
  },
];
